import { Box, Typography, styled } from "@material-ui/core";

export const CardsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  minWidth: 0
});

export const SupplierStatusPanel = styled(Box)({
  display: "flex",
  flexDirection: "column",
  background: "#FFF",
  border: "1px solid #E5E7EB",
  borderRadius: "0.5rem",
  boxShadow: "0 6px 16px rgba(17, 24, 39, 0.035)",
  padding: "1rem"
});

export const SupplierStatusTitle = styled(Typography)({
  color: "#111827",
  fontFamily: "Inter",
  fontSize: "0.875rem",
  fontWeight: 700,
  lineHeight: 1.3,
  marginBottom: "0.75rem"
});

export const StyledCardContent = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.75rem",
  minHeight: "3.8rem",
  padding: "0.55rem 0"
});

export const LastUpdatedCard = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.75rem",
  background: "#FFF",
  border: "1px solid #E5E7EB",
  borderRadius: "0.5rem",
  boxShadow: "0 6px 16px rgba(17, 24, 39, 0.035)",
  padding: "1rem"
});
